import { Spin } from "antd";
import OrderInfo from "../../../../../containers/order_info/order_info";
import { useLiveClientOrders } from "../../../../../hooks/order_list_views/useLiveClientsOrders.hook";

export default function LiveOrdersClient(){
    
    const hook = useLiveClientOrders()
    
    if(hook.loading) return(<Spin />);
    else if(hook.data == null) return <>Null</>
    else return(
        <OrderInfo
            hook={hook}
            type="live"
        />
    );
}